var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "container-avatars" },
    _vm._l(_vm.avatarArray, function(avatar, index) {
      return _c(
        "div",
        [
          _c(
            "el-badge",
            {
              staticClass: "item",
              attrs: {
                hidden:
                  !_vm.max ||
                  index !== _vm.avatarArray.length - 1 ||
                  _vm.rest === 0,
                value: "+" + _vm.rest
              }
            },
            [
              _c(
                "el-tooltip",
                {
                  attrs: {
                    placement: "top",
                    content: _vm.getValueFromObjectPath(_vm.label, avatar)
                  }
                },
                [
                  _c(
                    "el-avatar",
                    { style: _vm.avatarClass, attrs: { size: _vm.avatarSize } },
                    [
                      _vm._v(
                        _vm._s(
                          _vm.getFirstLetter(
                            _vm.getValueFromObjectPath(_vm.label, avatar)
                          )
                        )
                      )
                    ]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-f231ef72", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f231ef72","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AvatarList.vue
// module id = null
// module chunks = 